export default "__VITE_ASSET__DBLHTiC9__"